
/*@jsxRuntime automatic @jsxImportSource react*/
export const attributes = {
  "authors": ["ben-milne", "chase-merlin", "michael-mcallister"],
  "callToAction": {
    "heading": "Not attending conferences?",
    "subheading": "Book a time with our team.",
    "button": "Schedule time",
    "ctaUrl": "/contact",
    "externalUrl": true
  },
  "coverImage": {
    "alt": "October conferences for Brale | Brale Blog",
    "url": "/assets/blog/october-conferences-for-brale/cover.png"
  },
  "date": "2024-10-08",
  "description": "Join Brale at key October conferences to explore stablecoins. Meet our team, attend sessions, and learn how to integrate stablecoins into your product or ecosystem.",
  "discussLinkedIn": "https://www.linkedin.com/posts/brale_stablecoins-in-october-activity-7249062905407553536-f3al/",
  "discussTwitter": "https://x.com/brale_xyz/status/1844046656318353751/",
  "excerpt": "We're on the move in October. We'd love to meet you in London, Salt Lake City, San Francisco, Las Vegas, Los Angeles, or right back in Des Moines.",
  "ogImage": {
    "alt": "October conferences for Brale | Brale Blog",
    "url": "/assets/blog/october-conferences-for-brale/og-image.png"
  },
  "timeOverride": 4,
  "title": "October conferences for Brale"
};
import {Conference} from "~/components/blog/conference";
import {faArrowUpRight} from "@fortawesome/pro-light-svg-icons";
import {ExternalLink} from "~/components/site/external-link";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p"
  }, props.components);
  return <><_components.p>{"For the first time in Brale history, we're making a concerted effort to be at several conferences in October. Across the team, we'll be in Salt Lake City, Las Vegas, San Francisco, Los Angeles, and London throughout the month."}</_components.p>{"\n"}<_components.p>{"Below is a guide to where we will be, who is attending, and how to get a meeting. We hope to gather interest and partnerships as part of our last BETA group of clients and partners before a fully open release."}</_components.p>{"\n"}<_components.p>{"If you've been stablecoin curious, are interested in bringing native stablecoins to your app, emerging ecosystem, or embed them in your payment flows, we'd love to help."}</_components.p>{"\n"}<Conference id="rwa" />{"\n"}<Conference id="permissionless" />{"\n"}<Conference id="meridian" />{"\n"}<Conference id="money2020" />{"\n"}<Conference id="disrupt" className="border-b mb-24" /></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}
export default MDXContent;


export const filename = "october-conferences-for-brale.mdx";
export const headers = typeof attributes !== "undefined" && attributes.headers;
export const meta = typeof attributes !== "undefined" && attributes.meta;
export const handle = typeof attributes !== "undefined" && attributes.handle;
    